import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";

interface ImagePreviewProps {
  src: string;
  onPreview: () => void;
  onRemove: (e: React.MouseEvent) => void;
  loading?: boolean;
  styles: any;
}

export const ImagePreview: React.FC<ImagePreviewProps> = React.memo(
  ({ src, onPreview, onRemove, loading, styles }) => {
    const intl = useIntl();

    return (
      <div className={styles.imagePreview}>
        <img
          src={src}
          alt={intl.formatMessage({ id: "image.preview.alt" })}
          onClick={onPreview}
          style={{ opacity: loading ? 0.6 : 1 }}
        />
        <span className={styles.removeImage} onClick={onRemove}>
          ×
        </span>
        {loading && (
          <div className={styles.imageLoading}>
            <LoadingOutlined className={styles.blueIconSmall} />
          </div>
        )}
      </div>
    );
  }
);

ImagePreview.displayName = "ImagePreview";
